import React from 'react';
import FeedBackForm from './FeedBackForm';
import { BodySmall, Heading6 } from '../common/GlobalElements/Typography';

export default function Good(props) {
    return (
        <>
            <div className="tab-pane fade" id="good" role="tabpanel" aria-labelledby="good-tab">
                <div className="tab-pane-head">
                    <Heading6>
                        <span>Thanks </span> for your rating.
                    </Heading6>
                    <BodySmall>
                        Please let us know how we could have got 5 stars. Is there anything we could have improved on?
                    </BodySmall>
                </div>
                <FeedBackForm rating_type={props.rating_type} />
            </div>
        </>
    );
}
